module.exports = __webpack_public_path__ + "static/media/minnie_mouse.e057d336.jpg";